import { createContext, useContext } from "react";

export const ANONYMOUS_BOOTSTRAP = Object.freeze({
  status: "anonymous",
  user: null,
  onboarding: null,
  csrfToken: null,
  providers: [],
  pendingGeneration: null,
  draft: null,
  anonymousEntry: null,
  retry: () => {},
  refresh: async () => {},
  refreshCsrf: async () => ({ status: "anonymous" }),
  reresolveSession: async () => ({ status: "anonymous" }),
  applyOnboarding: () => {},
  completeLogout: () => {},
  presentation: "hidden",
});

export const AuthBootstrapContext = createContext(ANONYMOUS_BOOTSTRAP);

export default function useAuthBootstrap() {
  return useContext(AuthBootstrapContext);
}
